import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { MerchantService } from "../../services/Merchant.service";
import { handleApiError } from "../../utils/handleApiError";
import { useI18n } from "../../i18n";
import AdsSection from "../ads/AdsSection";
import { toast } from "react-toastify";

// Foto olmayan mağazalar üçün ad baş hərfli placeholder
const Avatar = ({ merchant }) =>
  merchant.photo ? (
    <img
      src={merchant.photo}
      alt=""
      loading="lazy"
      className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-2xl shadow-md"
    />
  ) : (
    <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl bg-gradient-to-br from-indigo-500 to-fuchsia-500 flex items-center justify-center shadow-md">
      <span className="text-3xl sm:text-4xl font-extrabold text-white">
        {merchant.name?.charAt(0)?.toUpperCase() || "?"}
      </span>
    </div>
  );

const StoreList = () => {
  const { t, tr } = useI18n();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await MerchantService.list();
        setStores(data.merchants || []);
      } catch (error) {
        toast.error(handleApiError(error, t));
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="text-white">
      {/* Hero */}
      <section className="page text-center pt-10 sm:pt-16 pb-10">
        <h1 className="text-3xl sm:text-5xl font-extrabold mb-3 drop-shadow-lg animate-fade-up">
          {t("home.title")}
        </h1>
        <p className="text-base sm:text-xl text-indigo-100 max-w-2xl mx-auto animate-fade-up">
          {t("home.subtitle")}
        </p>
      </section>

      {/* Mağazalar */}
      <section className="bg-gray-50 rounded-t-[2rem] sm:rounded-t-[2.5rem] shadow-inner pt-10 pb-2 page min-h-[50vh]">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {loading ? (
            Array.from({ length: 8 }).map((_, index) => (
              <div
                key={index}
                className="relative flex flex-col items-center justify-center rounded-2xl shadow-md bg-white w-full h-52 sm:h-64 p-5 overflow-hidden"
              >
                <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
                <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gray-200 rounded-2xl mb-4" />
                <div className="w-3/4 h-4 bg-gray-200 rounded-md mb-2" />
                <div className="w-1/2 h-3 bg-gray-200 rounded-md" />
              </div>
            ))
          ) : stores.length > 0 ? (
            stores.map((item) => (
              <Link key={item.id} to={`/store/${item.id}`} className="group">
                <div className="flex flex-col items-center justify-center rounded-2xl shadow-md bg-white w-full h-52 sm:h-64 hover:shadow-2xl hover:-translate-y-1 active:scale-[0.98] transition-all duration-300 p-4 sm:p-6">
                  <Avatar merchant={item} />
                  <h3 className="text-sm sm:text-lg font-bold text-gray-800 text-center mt-4 line-clamp-2 group-hover:text-indigo-600 transition">
                    {tr(item.name)}
                  </h3>
                  <span className="mt-2 sm:mt-3 text-[10px] sm:text-xs font-semibold text-indigo-500 bg-indigo-50 px-3 py-1 rounded-full text-center">
                    {t("home.view_campaigns")}
                  </span>
                </div>
              </Link>
            ))
          ) : (
            <div className="col-span-full text-center text-gray-500 py-16">
              <p className="text-5xl mb-4">🏪</p>
              <p className="text-xl font-semibold">{t("home.empty_title")}</p>
              <p className="text-sm mt-1">{t("home.empty_subtitle")}</p>
            </div>
          )}
        </div>

        {/* Admin paneldən yaradılan reklamlar */}
        <div className="max-w-6xl mx-auto">
          <AdsSection limit={6} />
        </div>
      </section>

      <style>{`
        @keyframes shimmer { 100% { transform: translateX(100%); } }
        .animate-shimmer { animation: shimmer 2s infinite; }
      `}</style>
    </div>
  );
};

export default StoreList;
